import React, { useState } from 'react'
import styles from './DatePickerComponent.module.css'
import { moment, isToday, isSameDay } from '../utils/dateUtils'

export default function DatePickerComponent({ selectedDate, onDateSelect }) {
    const [currentMonth, setCurrentMonth] = useState(moment(selectedDate || new Date()).toDate())
    
    // Get first day of the month and the number of days
    const currentMoment = moment(currentMonth)
    const firstDayOfMonth = currentMoment.clone().startOf('month')
    const daysInMonth = currentMoment.daysInMonth()
    const startingDayOfWeek = firstDayOfMonth.day() // 0 = Sunday, 1 = Monday, etc.
    
    // Get previous and next months for navigation
    const prevMonth = currentMoment.clone().subtract(1, 'month').startOf('month').toDate()
    const nextMonth = currentMoment.clone().add(1, 'month').startOf('month').toDate()
    
    const monthNames = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ]
    
    const dayNames = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
    
    const handleDateClick = (day) => {
        const clickedDate = currentMoment.clone().date(day).toDate()
        onDateSelect(clickedDate)
    }
    
    const handlePrevMonth = () => {
        setCurrentMonth(prevMonth)
    }
    
    const handleNextMonth = () => {
        setCurrentMonth(nextMonth)
    }
    
    const handleTodayClick = () => {
        const today = moment().toDate()
        setCurrentMonth(today)
        onDateSelect(today)
    }
    
    // Generate calendar days
    const calendarDays = []
    
    // Add empty cells for days before the first day of the month
    // Convert Sunday (0) to Monday start: Sunday becomes 6, Monday becomes 0
    const mondayStartDay = startingDayOfWeek === 0 ? 6 : startingDayOfWeek - 1
    for (let i = 0; i < mondayStartDay; i++) {
        calendarDays.push(<div key={`empty-${i}`} className={styles.emptyDay}></div>)
    }
    
    // Add days of the month
    for (let day = 1; day <= daysInMonth; day++) {
        const date = currentMoment.clone().date(day).toDate()
        const isSelected = selectedDate && isSameDay(date, selectedDate)
        const isTodayDate = isToday(date)
        
        calendarDays.push(
            <button
                key={day}
                className={`${styles.dayButton} ${isSelected ? styles.selected : ''} ${isTodayDate ? styles.today : ''}`}
                onClick={() => handleDateClick(day)}
            >
                {day}
            </button>
        )
    }
    
    return (
        <div className={styles.datePicker}>
            <div className={styles.header}>
                <button className={styles.navButton} onClick={handlePrevMonth}>
                    ‹
                </button>
                <h3 className={styles.monthYear}>
                    {currentMoment.format('MMMM YYYY')}
                </h3>
                <button className={styles.navButton} onClick={handleNextMonth}>
                    ›
                </button>
            </div>
            
            <div className={styles.dayHeaders}>
                {dayNames.map(day => (
                    <div key={day} className={styles.dayHeader}>{day}</div>
                ))}
            </div>
            
            <div className={styles.calendar}>
                {calendarDays}
            </div>
            
            <div className={styles.footer}>
                <button className={styles.todayButton} onClick={handleTodayClick}>
                    Today
                </button>
            </div>
        </div>
    )
}